import Cart from './views/Cart'
import Delivery from './views/Delivery'
import Payment from './views/Payment'

const route = [
  {
    path: '/panier',
    name: 'cart',
    component: Cart,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A','R','C','I']
    }
  },
  {
    path: '/livraison',
    name: 'cartdelivery',
    component: Delivery,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A','R','C','I']
    }
  },
  {
    path: '/paiement',
    name: 'cartpayment',
    component: Payment,
    meta: {
      layout: 'default',
      auth: true,
      role: ['A','R','C','I']
    }
  }
]

export default route